import { push } from 'connected-react-router';
import * as api from '../api';

const fetchCurrentSessionActions = api.fetchActions('auth', 'fetch-current-session');
const verifyCurrentSessionActions = api.fetchActions('auth', 'verify-current-session');
const createEtoSessionActions = api.fetchActions('auth', 'create-eto-session');

export const actionTypes = {
  SET_SESSION: 'auth.set-session',
  ...fetchCurrentSessionActions.actionTypes,
  ...verifyCurrentSessionActions.actionTypes,
  ...createEtoSessionActions.actionTypes,
  DELETE_CURRENT_SESSION_SUCCESS: 'auth.delete-current-session-success',
  DELETE_CURRENT_SESSION_FAILURE: 'auth.delete-current-session-failure',
  INVALIDATE_CURRENT_SESSION: 'auth.invalidate-current-session',
  INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE: 'auth.invalidate-current-session-unobtrusive',
};

export const fetchCurrentSession = () => api.getThunk('/sessions/current', null, fetchCurrentSessionActions);
export const verifyCurrentSession = (token) => api.getThunk('/sessions/verifySession', {token}, verifyCurrentSessionActions);
export const createEtoSession = (etoToken) => api.postThunk('/sessions/eto', { etoToken }, createEtoSessionActions);

export function setSession(session) {
  return {
    type: actionTypes.SET_SESSION,
    session
  }
}

export function redirectTo(returnUrl) {
  return (dispatch) => dispatch(push(returnUrl || '/'));
}

export function getCurrentSessionFromSecureToken(secureToken) {
  return (dispatch) => {
    dispatch(setBearerAuth(secureToken));
    return dispatch(fetchCurrentSession());
  }
}

export function verifySession(secureToken) {
  return (dispatch) => {
    dispatch(setBearerAuth(secureToken));
    return dispatch(verifyCurrentSession(secureToken));
  }
}

function invalidateCurrentSession() {
  return {
    type: actionTypes.INVALIDATE_CURRENT_SESSION
  }
}

function invalidateCurrentSessionUnobtrusive() {
  return {
    type: actionTypes.INVALIDATE_CURRENT_SESSION_UNOBTRUSIVE
  }
}

function setBearerAuth(secureToken) {
  return (dispatch) => {
    api.config.unauthorizedGetNotifier = () => {
      dispatch(invalidateCurrentSession());
    }
    api.config.unauthorizedPostNotifier = () => {
      dispatch(invalidateCurrentSessionUnobtrusive());
    }
  }
}
